export default "__VITE_ASSET__CReX2HKI__"